import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"รับรองวุฒิการศึกษาต่างประเทศในไทย — สภามหาวิทยาลัย + OCSC + ก.พ.","metaTitle":"รับรองวุฒิต่างประเทศ WES ECE OCSC ก.พ. NAATI | NYC","metaDesc":"รับรองวุฒิการศึกษาต่างประเทศ (Foreign Credential Recognition) กับ ก.พ. สภามหาวิทยาลัย OCSC WES ECE ครบวงจร แปล + Apostille + ยื่นเทียบวุฒิ"},"en":{"h1":"Foreign Credential Recognition in Thailand — MHESI + OCSC + Council","metaTitle":"Credential Recognition Thailand — WES ECE OCSC MHESI | NYC","metaDesc":"Foreign degree recognition in Thailand — MHESI, OCSC, Council of University. Also WES / ECE / UK ENIC / VETASSESS filings with translation + Apostille end-to-end."}} as const;

export const Route = createFileRoute("/education/credential-recognition")({
  head: () => {
    const url = `${SEO_SITE}/education/credential-recognition`;
    const c = meta.th;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/education/credential-recognition", "th")},
        { name: "description", content: ctaDesc(c.metaDesc, "/education/credential-recognition", "th")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/education/credential-recognition", "th")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/education/credential-recognition", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "th_TH" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/education/credential-recognition", "/en/education/credential-recognition")],
    };
  },
  component: () => <SubServicePage slug="education/credential-recognition" locale="th" />,
});
